<script setup lang="ts">
    import { provide } from 'vue';
    import { imageLibraryProvideName, type ImageLibraryProvide } from '@shared/components/Images/types';
    import { setupImageLibrary } from '@shared/components/Images/ImageLibrary';
    import ImageLibrary from '@shared/components/Images/ImageLibrary.vue';

    const imageLibrary = setupImageLibrary();
    provide<ImageLibraryProvide>(imageLibraryProvideName, {
        state: imageLibrary.state,
        newSrc: imageLibrary.newSrc,
        insert: imageLibrary.insert,
        load: imageLibrary.load,
        toggleShowLibrary: imageLibrary.toggleShowLibrary,
        uploadFile: imageLibrary.uploadFile,
        uploadFromUrl: imageLibrary.uploadFromUrl,
        uploadFromBase64: imageLibrary.uploadFromBase64,
        navigateToAiEdit: imageLibrary.navigateToAiEdit,
    });

    imageLibrary.state.isStandalone = true;
</script>

<template>
    <ImageLibrary />
</template>
